/**
 * The exploded view of the case with no frame (edges dissolve into the page), and what makes it
 * different written out beneath it. Static on purpose: nothing to click.
 */
const FEATURES = [
  {
    title: 'NFC Authentication',
    description: 'Each card is linked to a unique NFC chip for tamper-proof verification',
  },
  {
    title: 'Professional Grading',
    description: 'Expert graders evaluate your cards on a comprehensive 1-10 scale',
  },
  {
    title: 'Blockchain NFTs',
    description: 'Minted on Polygon with full ownership and transaction history',
  },
]

export default function CaseShowcase() {
  return (
    <div>
      <img
        src="/home/case-anatomy.jpg"
        width="912"
        height="576"
        alt="Exploded view of the M1NT G1 case: front and back glass, the frame with its NFC tag, and a graded card"
        loading="lazy"
        decoding="async"
        draggable="false"
        className="m1nt-art-fade mx-auto block h-auto w-full max-w-[960px] select-none"
      />

      <ul className="-mt-6 grid gap-x-10 gap-y-8 sm:-mt-10 md:grid-cols-3">
        {FEATURES.map((feature) => (
          <li key={feature.title} className="border-t border-m1-line pt-6">
            <h3 className="font-m1-display text-[26px] font-normal leading-tight tracking-[-0.01em] text-m1-ink">
              {feature.title}
            </h3>
            <p className="mt-3 text-[16px] font-light leading-relaxed text-m1-ink-soft">
              {feature.description}
            </p>
          </li>
        ))}
      </ul>
    </div>
  )
}
